<template>
    <div>
        <b-btn
            @click="chat"
            variant="light"
            block
            class="rounded-0 mt-0"
            :size="$screen.lg ? 'lg' : 'sm'"
        >
            <font-awesome-icon icon="fa-duotone fa-message-dots" size="lg" />
            <div>
                {{ $t("Message") }}
            </div>
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState("profile", ["profile"]),
    },
    methods: {
        chat() {
            this.$store.dispatch("profile/viewProfile", {
                userId: this.profile.id,
                profile: this.profile,
                view: "conversation",
            });
        },
    },
};
</script>